import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Link } from "react-router";
import { ROUTES as CLINICAL_CODES_TRANSFORMATIONS_ROUTES } from "@/clinical-codes-transformations/navigation";
import Icd10CodesList from "./Icd10CodesList";
import Opcs4CodesList from "./Opcs4CodesList";
import { useState } from "react";

const ClinicalCoding = () => {
  const [selectedCodeType, setSelectedCodeType] = useState<"ICD-10" | "OPCS-4">("ICD-10");
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Clinical Coding</h1>
        <p className="text-muted-foreground">Manage clinical codes and transformations</p>
      </div>

      {/* New Transformations - Full Width */}
      <Card className="w-full">
        <CardHeader className="flex flex-row items-center justify-between">
          <div>
            <CardTitle>Clinical Code Transformations</CardTitle>
            <CardDescription>
              Create rules to automatically generate clinical codes based on template conditions
            </CardDescription>
          </div>
          <Link to={`${CLINICAL_CODES_TRANSFORMATIONS_ROUTES.clinicalCodeTransformations.route}`}>
            <Button>Manage Transformations</Button>
          </Link>
        </CardHeader>
      </Card>

      <Separator />

      {/* Clinical Code Management Section */}
      <div className="grid gap-12 md:grid-cols-1">
        <Card>
          <CardHeader>
            <div className="flex flex-row items-center justify-between">
              <CardTitle>Clinical Codes</CardTitle>
              <div className="flex gap-2">
                <Button
                  variant={selectedCodeType === "ICD-10" ? "default" : "outline"}
                  onClick={() => setSelectedCodeType("ICD-10")}
                  size="sm"
                >
                  ICD-10
                </Button>
                <Button
                  variant={selectedCodeType === "OPCS-4" ? "default" : "outline"}
                  onClick={() => setSelectedCodeType("OPCS-4")}
                  size="sm"
                >
                  OPCS-4
                </Button>
              </div>
            </div>
          </CardHeader>
          <CardContent>{selectedCodeType === "ICD-10" ? <Icd10CodesList /> : <Opcs4CodesList />}</CardContent>
        </Card>
      </div>
    </div>
  );
};

export default ClinicalCoding;
